module.exports = __webpack_public_path__ + "static/1402_large-050b2d64c540dd7bd7761290634e77b7.jpg";